import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BarOptions } from '../../../utils/models/bar-options';
import { customColorSets } from '../../../utils/custom-color-sets';

/**
 * Bar vertical stacked chart
 * @author Prasanth Venkatesan
 */
@Component({
  selector: 'neu-charts-bar-vertical-stacked',
  template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-bar-vertical-stacked
      [scheme]="colorScheme"
      [results]="data"
      [gradient]="gradient"
      [xAxis]="options.showXAxis"
      [yAxis]="options.showYAxis"
      [legend]="options.showLegend"
      [showXAxisLabel]="options.showXAxisLabel"
      [showYAxisLabel]="options.showYAxisLabel"
      [xAxisLabel]="options.xAxisLabel"
      [yAxisLabel]="options.yAxisLabel"
      [barPadding]="options.barPadding"
      (select)="mSelectedEvent($event)">
    </ngx-charts-bar-vertical-stacked>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
  styles: [`.chart-container{width:100%;height:100%}`]
})
export class BarVerticalStackedComponent implements OnInit {

    @Input('data') data: any;
    @Input('options') customOptions: BarOptions;
    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    options: BarOptions = new BarOptions();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {
        Object.assign(this.options, this.customOptions);
    }

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
